export default "__VITE_ASSET__DPz9L3Sf__"